import { render } from "./GdprConsent.vue?vue&type=template&id=17a5e9d6&scoped=true"
import script from "./GdprConsent.vue?vue&type=script&lang=js"
export * from "./GdprConsent.vue?vue&type=script&lang=js"

import "./GdprConsent.vue?vue&type=style&index=0&id=17a5e9d6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17a5e9d6"]])

export default __exports__